import * as React from 'react';
import { formatDateToBR } from '../../../utils/time';
import styles from "./styles.module.scss";
import {DateInfo} from "../../interfaces";

interface SEFormUserActionPros {
    data?: DateInfo
}

export const SEFormUserAction: React.FC<SEFormUserActionPros> = ({data}) => {
    if(!data) return null;
    const {atualizadoPor, criadoPor, dataCriacao, ultimaAtualizacao} = data;
    return (
        <div className={styles.containerUserActions}>
            {!!atualizadoPor && (
                <h5>
                    Atualizado em {" "}<b>{formatDateToBR(ultimaAtualizacao)}</b> por{" "}<b>{atualizadoPor?.nome}</b>
                </h5>
            )}
            
            {!!criadoPor && (
                <h5>
                    Criado em{" "}<b>{formatDateToBR(dataCriacao)}</b> por{" "}<b>{criadoPor?.nome}</b>
                </h5>
            )}
        </div>
    );
}
